var map = {
	"./customer-bg.webp": 1510,
	"./customer-img.webp": 1511,
	"./dice-img.webp": 1512,
	"./games-img.webp": 1513,
	"./lc-img.webp": 1514,
	"./lottery-img.webp": 1515,
	"./mission-bg.webp": 1516,
	"./mission-img-2.webp": 1517,
	"./mission-img.webp": 1518,
	"./mission-main-bg.webp": 1519,
	"./mobile-bg.webp": 1520,
	"./p2p-img.webp": 1521,
	"./product-bg.webp": 1522,
	"./product-main-bg.webp": 1523,
	"./sb-provider.webp": 1524,
	"./sbo-provider.webp": 1525,
	"./side-bar-bg.webp": 1526,
	"./slot-img.webp": 1527,
	"./spade-img.webp": 1528,
	"./sport-img.webp": 1529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;